/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Error_UnknownInputs */



/**
* | output |
* | --- |
* | "Unknown error" |
*
* @param {Common_Error_UnknownInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const common_error_unknown = /** @type {((inputs?: Common_Error_UnknownInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Error_UnknownInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Erreur inconnue")
	if (locale === "es") return /** @type {LocalizedString} */ ("Error desconocido")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Erro desconhecido")
	if (locale === "it") return /** @type {LocalizedString} */ ("Errore sconosciuto")
	return /** @type {LocalizedString} */ ("Unknown error")
});